import { useConnectWallet } from '@web3-onboard/react';
import cx from 'classnames';
import { BankxButton } from 'components/BankxButton';
import { BankxDashboardLayout } from 'components/layouts/BankxDashboardLayout';
import { PurchaseNFTBox } from 'components/PurchaseNFTBox';
import ReferralFooter from 'components/ReferralFooter';
import useOnScreen from 'hooks/useOnScreen';
import useRecursiveTimeout from 'hooks/useRecursiveTimeout';
import { useReferrals } from 'hooks/useReferrals';
import React, {
    useCallback, useRef, useState
} from 'react';

function BuyNFTPage() {
    const [{ wallet }] = useConnectWallet();
    const userAddress = wallet?.accounts[0].address;
    const { referrer: referrerAddress } = useReferrals();

    // video autoplay
    const [playing, setPlaying] = useState(0);
    const ref = useRef<HTMLDivElement>(null);
    const isVisible = useOnScreen(ref);
    const playVideo = useCallback(() => {
        if (isVisible && !playing) {
            setPlaying(1);
        }
    }, [
        setPlaying,
        isVisible,
        playing
    ]);
    useRecursiveTimeout(playVideo, 100);

    return (
        <BankxDashboardLayout>
            <link rel='stylesheet' href='/css/landing.css' />
            <div
                className='landing_container'
                style={{
                    paddingBottom: 0,
                }}
            >
                <h1>The FIRST Stablecoin NFT That Pays YOU!</h1>
                <br /><br />

                <h3>
                    <b>Each NFT will be paid 1,000 XSD&apos;s when the XSD stablecoin minted reaches $100M.</b>{' '}
                    Thereafter, it is 200 XSD for each NFT for every $100M in stablecoin minted.
                </h3>
                <br /><br />

                <p>
                    <b>Each NFT increases your Token Lockup Reward earnings:</b>{' '}
                    Lockup the NFT first. Then, lockup BankX tokens in the Token Lockup Rewards for accelerated earnings.
                    Each NFT increases your Token Lockup Rewards by 10%.
                    Maximum of 5 can be locked up per Token Lockup Rewards.
                </p>
                <br /><br />

                <p>
                    <b>Private Telegram and Discord</b> with access to BankX information before it is released to the public.
                </p>
                <br /><br />

                <div ref={ref} className='bankx-iframe-container'>
                    <iframe
                        src={`https://www.youtube.com/embed/EfJCHSetwBg?rel=0&amp;autoplay=${playing}&mute=1`}
                        title='YouTube video player'
                        frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                        className='youtubeVideo'
                    />
                </div>
            </div>
            <div className='profit nft-section landing_container'>
                <h1>NFTs for sale:</h1>
                <div className='nft-cards'>
                    {[['Silver Bar', 'Transformation'], ['XSD', 'Electricity']].map((nftNames, index) => {
                        const [a, b] = nftNames;
                        const k = index * 2;

                        return (
                            <div key={index} className='nft-cards-row'>
                                <div className="nft-card">
                                    <img src={`/images/nft/${k + 1}.png`} alt={`Currency Creators NFT, ${a}`} />
                                </div>

                                <div className="nft-card">
                                    <img src={`/images/nft/${k + 2}.png`} alt={`Currency Creators NFT, ${b}`} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className='landing_container'>
                <h3 style={{ marginTop: 42 }}>
                    Meaning Behind The NFT
                </h3>
                <p>
                    We believe that currency creation should be done by and benefit the
                    individual. BankX is the first stablecoin built for individual
                    freedom. When you mint the XSD stablecoin, you earn interest the
                    entire time it is in circulation. This is all done with complete
                    autonomy. It is just you and decentralized machines (blockchain).
                    The images depict the minting process and the transformation BankX
                    is bringing to legacy banking. We see an unknown minter bring value
                    to the system (a silver bar since the stablecoin is pegged to the
                    price of 1 gram of silver). This value is transformed in to an
                    unstoppable stablecoin. In the final image, the XSD stablecoin has
                    an electrifying force. When people use BankX and see what it can do
                    for them, it will spread everywhere.
                </p>

                <p style={{ width: '100%', }}>
                    *Please read the Currency Creators Manifesto:{' '}
                    <a href='https://bankx.io/' target='_blank' rel='noopener noreferrer'>www.BankX.io</a> or{' '}
                    <a href=' https://t.me/BankXio/119512' target='_blank' rel='noopener noreferrer'>t.me/BankXio/119512</a>
                </p>

                <br />
                <div className='buy-nft-container'>
                    <div className="nft-swap-box-wrapper">
                        <div className={cx('main-card-dark', 'single-card')}>
                            <div className={cx('lg-w')}>
                                <div className='main-card-body'>
                                    <PurchaseNFTBox
                                        className='nft-swap-box'
                                        disableDarkTheme={false}
                                        hasSettings={false}
                                        hasLandingPageRedirect
                                        userAddress={userAddress}
                                        referrerAddress={referrerAddress}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReferralFooter
                        // userAddress={userAddress}
                        copyType='NFT'
                        route='buy-nft'
                    />
                </div>
                <div style={{
                    display: 'flex',
                    gap: '2rem',
                    marginTop: '5rem',
                }}>
                    <BankxButton onClick={() => window.open('https://docs.bankx.io/', '_blank', 'noopener noreferrer')}>
                        Still Have More Questions?
                    </BankxButton>

                    <BankxButton onClick={() => window.open('https://t.me/BankXio', '_blank', 'noopener noreferrer')}>
                        Join The Conversation
                    </BankxButton>

                    <BankxButton onClick={() => window.open('/#/nft-leaderboard', '_blank', 'noopener noreferrer')}>
                        NFT Leaderboard
                    </BankxButton>
                </div>
            </div>
        </BankxDashboardLayout>
    );
}

export default BuyNFTPage;
